/**
	An identity function
	@param {any} d The value to return.
	@returns {any}
*/
export default function identity(d) {
	return d;
}
